import React from "react";

export default function LoadingWave({ message }) {
  const fruits = ["🍎", "🥦", "🥩", "🫐", "🍌"];

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(255,255,255,0.8)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div style={{ display: "flex", gap: "12px", fontSize: "30px" }}>
        {fruits.map((fruit, index) => (
          <span
            key={index}
            style={{
              display: "inline-block",
              animation: `bounce 0.6s ease-in-out ${index * 0.1}s infinite`,
            }}
          >
            {fruit}
          </span>
        ))}
      </div>
      {message && (
        <span style={{ marginTop: "12px", fontSize: "16px", fontWeight: "bold", color: "#333" }}>
          {message}
        </span>
      )}

      {/* Add keyframes for bounce */}
      <style>
        {`
          @keyframes bounce {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-15px); }
          }
        `}
      </style>
    </div>
  );
}
